import { Injectable } from '@angular/core'
import { filter, tap } from 'rxjs/operators'
import { BehaviorSubject, Observable } from 'rxjs'

import { DeviceSensor } from '@shared/models/sensor.model'
import { FilterValues } from '../models/filter-values.model'
import { DeviceSensorsApiService } from './device-sensors-api.service'

@Injectable()
export class DeviceSensorsService {
  constructor(private readonly deviceSensorsApiService: DeviceSensorsApiService) {}

  private readonly deviceSensors: BehaviorSubject<DeviceSensor[]> = new BehaviorSubject<DeviceSensor[]>(null)
  readonly deviceSensors$ = this.deviceSensors.asObservable().pipe(filter(Boolean))

  setDeviceSensors(sensors: DeviceSensor[]): void {
    this.deviceSensors.next(sensors)
  }

  getDeviceSensorsList(id: number | string, filterValues: FilterValues): Observable<DeviceSensor[]> {
    return this.deviceSensorsApiService
      .getDeviceSensorsList(id, filterValues)
      .pipe(tap((sensors: DeviceSensor[]) => this.setDeviceSensors(sensors)))
  }
}
